export const BooleanBodyTemplate = (status?: boolean) => {
  if (status == null) return null

  return (
    <>
      {status ? (
        <i className="pi pi-check" style={{ color: 'var(--green-500)' }}></i>
      ) : (
        <i className="pi pi-times" style={{ color: 'var(--red-500)' }}></i>
      )}
    </>
  )
}
